import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'app/model/base/annotation';
import { SalesforceV2LinkedServiceAdapter } from './salesforce-v2-linkedservice.adapter';
import { SalesforceServiceCloudV2LinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudV2LinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                environmentUrl: '*',
                clientId: '*',
                clientSecret: 'secret',
                apiVersion: '*'
            },
            parameters: '*'
        }
    }
})
export class SalesforceServiceCloudV2LinkedServiceAdapter extends SalesforceV2LinkedServiceAdapter {
    protected modelConstructor(): new () => SalesforceServiceCloudV2LinkedService {
        return SalesforceServiceCloudV2LinkedService;
    }

    protected model(): IModel {
        return SalesforceServiceCloudV2LinkedService.MODEL;
    }
}
